// Kısa haptic feedback — destekleyen cihazlarda kısa bir titreşim verir.
// iOS Safari Web Vibration API'yi desteklemiyor; sessizce fallback olur.
export function haptic(pattern = 10) {
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
      navigator.vibrate(pattern);
    }
  } catch (e) {}
}
